import volumeBoosts from './videoVolumeBoosts.json';

export const VIDEO_VOLUME_BOOSTS = volumeBoosts;

function isGlob(key) {
  return key.includes('*') || key.includes('?');
}

function globToRegExp(glob) {
  const escaped = glob.replace(/[.+^${}()|[\]\\]/g, '\\$&');
  const regexBody = escaped.replace(/\*/g, '.*').replace(/\?/g, '.');
  return new RegExp(regexBody);
}

function sourceMatchesKey(source, key) {
  if (isGlob(key)) {
    return globToRegExp(key).test(source);
  }

  return source.includes(key);
}

export function getVolumePercentForSource(source, overridePercent) {
  if (overridePercent != null && !Number.isNaN(Number(overridePercent))) {
    return Number(overridePercent);
  }

  if (!source) {
    return 100;
  }

  const sourceString = String(source);
  const entries = Object.entries(VIDEO_VOLUME_BOOSTS);
  let globMatch;

  for (let i = 0; i < entries.length; i += 1) {
    const key = entries[i][0];
    const percent = entries[i][1];
    if (!key || !sourceMatchesKey(sourceString, key)) {
      continue;
    }

    if (!isGlob(key)) {
      return Number(percent);
    }

    if (globMatch == null) {
      globMatch = Number(percent);
    }
  }

  return globMatch != null ? globMatch : 100;
}
